import { render } from "./AssignUser.vue?vue&type=template&id=2806c868&ts=true"
import script from "./AssignUser.vue?vue&type=script&lang=ts"
export * from "./AssignUser.vue?vue&type=script&lang=ts"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__